








































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import { availableCompanyTypes, availableGenders, availableLicenseTypes, availableModules } from '@/api/types'
import { User } from '@/api/model/user'

@Component
export default class CreateCompanyLicenseForm extends Vue {
    @Prop({ type: User }) user!: User
    @Prop({ type: Company }) company!: Company

    get companyTypeOptions(): Array<{ label: string, value: string }> {
        return availableCompanyTypes().map(value => {
            return {
                label: this.$t(`company-type.${ value }`).toString(),
                value,
            }
        })
    }

    get userGenderTypes(): Array<{ label: string, value: string }> {
        return availableGenders().map(value => {
            return {
                label: this.$t(`gender.${ value }`).toString(),
                value,
            }
        })
    }

    get licenseTypeOptions() {
        return availableLicenseTypes().map(value => {
            return {
                label: this.$t(`license.list.licenseType.${ value }`).toString(),
                value,
            }
        })
    }

    get moduleOptions() {
        return availableModules().map(value => {
            return {
                label: this.$t(`license.list.modules.${ value }`).toString(),
                value,
            }
        })
    }

    getModuleValue(module: string): boolean {
        return this.company.modules.includes(module)
    }

    setModuleValue(module: string, value: boolean): void {
        const index = this.company.modules.indexOf(module)

        if (value === true && index === -1) {
            this.company.modules.push(module)
        }

        if (value === false && index !== -1) {
            this.company.modules.splice(this.company.modules.indexOf(module), 1)
        }
    }
}
